import type { NpcData, ZoneLink } from '@thottbot/shared';
import { ArtifactLink } from '../../components/ArtifactLink';
import { FieldTable, prose, refList, type RefView } from './FieldTable';
import { Locations } from './Locations';
import { ZoneMap } from './ZoneMap';

export function NpcFields({ data, name, zone }: { data: NpcData; name: string; zone?: ZoneLink }) {
  // Trainers: only abilities resolved to a page, so a partial seed never shows bare names.
  const teaches = (data.teaches as RefView[] | undefined)?.filter((r) => r.slug);
  const level =
    data.levelMin !== undefined && data.levelMax !== undefined && data.levelMin !== data.levelMax
      ? `${data.levelMin} - ${data.levelMax}`
      : (data.levelMin ?? data.levelMax);
  return (
    <FieldTable
      rows={[
        { label: 'Level', value: level },
        { label: 'Type', value: data.creatureType },
        { label: 'Faction', value: data.faction },
        {
          label: 'Zone',
          value: data.zone && zone ? <ArtifactLink type="zone" slug={zone.slug} name={data.zone} /> : data.zone,
        },
        { label: 'Title', value: prose(data.description) },
        {
          label: 'Map',
          value: data.zone && data.locations?.length && (
            <ZoneMap
              zone={{ name: data.zone, areaId: zone?.areaId }}
              mapUrl={zone?.mapUrl}
              groups={[{ label: name, locations: data.locations }]}
            />
          ),
        },
        { label: 'Locations', value: <Locations locations={data.locations} /> },
        { label: 'Starts quests', value: refList(data.startsQuests, 'quest') },
        { label: 'Ends quests', value: refList(data.endsQuests, 'quest') },
        { label: 'Drops', value: refList(data.drops, 'item', data.lootedCount) },
        { label: 'Sells', value: refList(data.sells, 'item') },
        { label: 'Teaches', value: refList(teaches, 'ability') },
      ]}
    />
  );
}
